import { render, staticRenderFns } from "./NavItemTooltip.vue?vue&type=template&id=530ecad4&"
import script from "./NavItemTooltip.vue?vue&type=script&lang=ts&"
export * from "./NavItemTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports